import auth from 'b2b-common/services/auth'

import privateView from './index'

import accountView from './account'
import homeView from './home'
import { packageViews, tourViews } from './package/router'
import tourCacheViews from './tour/router'
import hotelViews from './hotel/router'
import bookingViews from './bookings/router'
import otherViews from './other/router'

export default {
  path: 'private',
  name: 'Private/Default',
  component: privateView,
  redirect: { name: 'Private/Package' },
  beforeEnter: (to, from, next) => {
    auth.isLoggedIn().then((isLoggedIn) => {
      if (isLoggedIn) next()
      else next({ name: 'Public/Default' })
    }, () => {
      next({ name: 'Public/Default' })
    })
  },
  children: [
    packageViews,
    tourViews,
    tourCacheViews,
    hotelViews,
    bookingViews,
    otherViews,
    {
      path: 'cont',
      name: 'Private/Account',
      component: accountView
    },
    {
      path: 'home',
      name: 'Private/Home',
      component: homeView
    },
    {
      path: 'logout',
      name: 'Private/Logout',
      beforeEnter: (to, from, next) => {
        auth.logout()
          .then(() => {
            // TODO: inform of succcesful logout
            next({ name: 'Public/Default' })
          })
          .catch(() => {
            // TODO: inform user about problem
            next({ name: 'Private/Default' })
          })
      }
    }
  ]
}
